/* Contraband reviews (2026-10-09) - reviewer names, sorting, filtering and "Show more",
 * Amazon-style (Chris: "sort by newest to oldest, see specific reviews by star rating").
 * Names are fetched here, in the shopper's browser, from reviews.contraband.com - never
 * written into the page's HTML - so Google never indexes them (robots.txt blocks that
 * URL). Names are inserted as TEXT (textContent), never HTML.
 * Source: shopify_theme/ in the Contraband HQ repo. */
(function () {
  var box = document.getElementById('reviews');
  if (!box) return;
  var list = box.querySelector('.cb-reviews__list');
  var items = list ? Array.prototype.slice.call(list.querySelectorAll('.cb-review')) : [];
  var FALLBACK = 'Contraband customer';

  function attr(el, name) { return el.getAttribute('data-' + name) || ''; }
  function each(selector, fn) { Array.prototype.forEach.call(box.querySelectorAll(selector), fn); }

  // ---- Reviewer names ----
  var ids = [];
  items.forEach(function (el) { if (/^\d+$/.test(attr(el, 'review-id'))) ids.push(attr(el, 'review-id')); });
  function fill(names) {
    items.forEach(function (el) {
      var slot = el.querySelector('.cb-review__name');
      if (slot) slot.textContent = (names && names[attr(el, 'review-id')]) || FALLBACK;
    });
  }
  if (ids.length && window.fetch) {
    fetch(box.getAttribute('data-names-url') + ids.join(','), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(fill)
      .catch(function () { fill({}); });
  } else {
    fill({});
  }

  if (!list) return;

  // ---- Sort, filter, 10 at a time ----
  var PAGE = 10;
  var state = { sort: 'newest', star: 0, photos: false, verified: false, shown: PAGE };
  var sortSelect = box.querySelector('[data-cb-sort]');
  var more = box.querySelector('[data-cb-more]');
  var showing = box.querySelector('[data-cb-showing]');
  var empty = box.querySelector('[data-cb-empty]');

  function compare(a, b) {
    var ra = +attr(a, 'rating'), rb = +attr(b, 'rating');
    var da = attr(a, 'date'), db = attr(b, 'date');
    var ia = +attr(a, 'index'), ib = +attr(b, 'index'); // 0 = newest (HQ lists newest first)
    if (state.sort === 'oldest') return ib - ia;
    if (state.sort === 'highest') return (rb - ra) || (ia - ib);
    if (state.sort === 'lowest') return (ra - rb) || (ia - ib);
    return ia - ib;
  }

  function apply() {
    var sorted = items.slice().sort(compare);
    var matching = sorted.filter(function (el) {
      return (!state.star || +attr(el, 'rating') === state.star)
        && (!state.photos || +attr(el, 'photos') > 0)
        && (!state.verified || attr(el, 'verified') === '1');
    });
    sorted.forEach(function (el) { list.appendChild(el); el.classList.add('cb-hidden'); });
    matching.slice(0, state.shown).forEach(function (el) { el.classList.remove('cb-hidden'); });

    if (showing) {
      var n = matching.length;
      showing.textContent = n ? 'Showing ' + Math.min(state.shown, n) + ' of ' + n + ' review' + (n === 1 ? '' : 's') : '';
    }
    if (empty) empty.hidden = matching.length > 0;
    if (more) more.hidden = matching.length <= state.shown;

    each('[data-cb-star]', function (c) { c.classList.toggle('is-active', +c.getAttribute('data-cb-star') === state.star); });
    each('.cb-hist__row', function (row) { row.classList.toggle('is-active', +row.getAttribute('data-star') === state.star); });
    each('[data-cb-photos]', function (c) { c.classList.toggle('is-active', state.photos); });
    each('[data-cb-verified]', function (c) { c.classList.toggle('is-active', state.verified); });
  }

  function restart() { state.shown = PAGE; apply(); }

  if (sortSelect) sortSelect.addEventListener('change', function () { state.sort = sortSelect.value; restart(); });
  each('[data-cb-star]', function (c) {
    c.addEventListener('click', function () { state.star = +c.getAttribute('data-cb-star'); restart(); });
  });
  // A bar in the summary = "show only N-star reviews" (click it again to show all).
  each('.cb-hist__row', function (row) {
    row.addEventListener('click', function () {
      var star = +row.getAttribute('data-star');
      state.star = state.star === star ? 0 : star;
      restart();
      var tools = box.querySelector('.cb-tools');
      if (tools && tools.scrollIntoView) tools.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  each('[data-cb-photos]', function (c) { c.addEventListener('click', function () { state.photos = !state.photos; restart(); }); });
  each('[data-cb-verified]', function (c) { c.addEventListener('click', function () { state.verified = !state.verified; restart(); }); });
  if (more) more.addEventListener('click', function () { state.shown += PAGE; apply(); });

  apply();
})();
